/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/rules-of-hooks */
import { useMemo } from 'react';

import { Link } from 'react-router-dom';
import { useAppWrapperContext } from 'ui/layouts/AppWrapper';
import { useAdminParams } from 'utils/helpers';
import { Notification } from 'utils/types';

const DataRecordDescription = {
  DATA_RECORD_EXPORT: (_n?: Notification) =>
    'Your file is ready to be downloaded',
  DATA_RECORD_IMPORT: (_n?: Notification) => 'File import complete',
};

const DataRecordLogs = {
  DATA_RECORD_EXPORT: {
    title: 'File Export Complete',
    description: (_n?: Notification) => {
      return DataRecordDescription.DATA_RECORD_EXPORT(_n);
    },
    element: ({ meta }: Notification) => {
      return (
        <>
          <div className="text-title font-semibold text-sm line-clamp-2">
            {DataRecordDescription['DATA_RECORD_EXPORT']()}
          </div>
          <div className="flex font-normal space-x-2 text-sm line-clamp-2">
            <span>
              Click on the{' '}
              <span>
                <a
                  className="hover:text-primary-base underline"
                  href={meta?.fileUrl}
                  target="__blank"
                >
                  link
                </a>{' '}
              </span>
              to download
            </span>
          </div>
        </>
      );
    },
  },
  DATA_RECORD_IMPORT: {
    title: 'File Import Complete',
    description: (_n?: Notification) => {
      return DataRecordDescription.DATA_RECORD_IMPORT(_n);
    },
    element: ({ meta }: Notification) => {
      const {
        state: { isPreview },
      } = useAppWrapperContext();
      const { accountId, accountUserId } = useAdminParams();

      const link = useMemo(() => {
        if (meta?.source === 'LEAD') {
          return isPreview
            ? `/preview/accounts/${accountId}/users/${accountUserId}/contact/leads`
            : `/contact/leads`;
        }

        if (meta?.source === 'COMPANY') {
          return isPreview
            ? `/preview/accounts/${accountId}/users/${accountUserId}/contact/companies`
            : `/contact/companies`;
        }

        return isPreview
          ? `/preview/accounts/${accountId}/users/${accountUserId}/sales/deals`
          : `/sales/deals`;
      }, [accountId, accountUserId, isPreview, meta?.source]);
      const label =
        meta?.source === 'LEAD'
          ? 'Leads'
          : meta?.source === 'COMPANY'
            ? 'Companies'
            : 'Deals';
      return (
        <>
          <div className="text-title font-semibold text-sm line-clamp-2">
            {DataRecordDescription['DATA_RECORD_IMPORT']()}
          </div>
          <div className="flex font-normal space-x-2 text-sm line-clamp-2">
            <span>
              Go to{' '}
              <span>
                <Link className="hover:text-primary-base underline" to={link}>
                  {label} Page
                </Link>
              </span>
            </span>
          </div>
        </>
      );
    },
  },
};

export default DataRecordLogs;
